/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "FezaiTech",
  title: "Hi all, I'm Hamza",
  subTitle: emoji(
    "A passionate Mobile & Game Developer having experience in building mobile apps with Flutter and 2D games with Flame Engine, along with projects using Unity, Python, and other powerful tools and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/12547pVwIg3EpQtPdUQ44mRnrLldcaQJ_/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  youtube: "https://www.youtube.com/@hamzabayar3547",
  linkedin: "https://www.linkedin.com/in/hamza-bayar-251b7b234/",
  instagram: "https://www.instagram.com/hamzabayar234/",
  github: "https://github.com/Hamza-Bayar-2",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "MOBILE APP & GAME DEVELOPER",
  skills: [
    emoji("⚡ Cross-platform mobile app development using Flutter and Dart"),
    emoji(
      "⚡ 2D game development with Flame Engine and Unity for both mobile and desktop platforms"
    ),
    emoji(
      "⚡ Desktop application development using Python and other technologies"
    ),
    emoji(
      "⚡ Proficient in version control and team collaboration using Git, GitHub, and GitKraken"
    ),
    emoji(
      "⚡ Integration of third-party tools and services such as Firebase and Arduino"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fas fa-mobile-alt"
    },
    {
      skillName: "Flame",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Unity",
      fontAwesomeClassname: "fab fa-unity"
    },
    {
      skillName: "C#",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Dart",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "C",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-gitkraken"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Ondokuz Mayis Uninersity",
      logo: require("./assets/images/logos/omuLogo.png"),
      subHeader: "Bachelor's degree in Computer Engineering",
      duration: "2021 - 2025",
      desc: "Took courses about Mobile Development, Web Development, Algorithms, Data Structures, Software Testing",
      descBullets: ["CGPA: 3.43"]
    },
    {
      schoolName: "Kastamonu Anatolia High School",
      logo: require("./assets/images/logos/aplLogo.png"),
      duration: "2017 -  2021"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Flutter 🐦", //Insert stack or technology you have experience in
      progressPercentage: "75%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Flame Engine 🔥",
      progressPercentage: "80%"
    },
    {
      Stack: "Unity 🎮",
      progressPercentage: "65%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Flame Game Developer",
      company: "Dutch Game Studio",
      companylogo: require("./assets/images/logos/dgsLogo.png"),
      date: "November 2024 – Present",
      desc: "After completing my Erasmus+ internship, I continued working part-time at Dutch Game Studio, contributing to the development of mobile apps and games using Flutter and the Flame engine. Projects included titles such as Knife Hit, Coin Catcher, Space Invaders, Gold Catcher, Line Up, Quick Draw, and Whack a Mole.",
      descBullets: [
        "Designing and implementing core game mechanics and UI components using Flutter and Flame.",
        "Collaborating with the team to build and maintain multiple game features across various titles.",
        "Refactoring and customizing third-party packages to align with project-specific needs.",
        "Identifying and resolving performance bottlenecks and software bugs, leading to increased application efficiency and stability.",
        "Contributing to the development of production-ready application pages with a focus on responsiveness, usability, and code quality."
      ]
    },
    {
      role: "FezaiTech Organization",
      company: "FezaiTech",
      companylogo: require("./assets/images/logos/fezaitechLogo.png"),
      date: "September 2022 – Present",
      desc: "As a founding member of the FezaiTech Organization, which I co-founded with my classmates on GitHub, I contributed to the development of mobile applications, desktop software, and cross-platform games."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Team Projects",
  subtitle:
    "SOME PROJECTS I DEVELOPED WITH MY FEZAITECH ORGANIZATION TEAMMATES",
  projects: [
    {
      image: require("./assets/images/logos/budgetWiseLogo.png"),
      projectName: "ButceTakip",
      projectDesc:
        "A comprehensive budget tracking mobile application built with Flutter and Dart, featuring expense management, budget planning, and financial analytics.",
      footerLink: [
        {
          name: "View on GitHub",
          url: "https://github.com/Hamza-Bayar-2/ButceTakip"
        },
        {
          name: "Download on Google Play",
          url: "https://play.google.com/store/apps/details?id=com.fezaitech.butcetakip"
        }
      ]
    },
    {
      image: require("./assets/images/logos/theHunterLogo.png"),
      projectName: "The Hunter Mini Game",
      projectDesc:
        "A collection of mini games developed using Flutter and Flame Engine, featuring various 2D game mechanics and interactive gameplay experiences.",
      footerLink: [
        {
          name: "View on GitHub",
          url: "https://github.com/Hamza-Bayar-2/mini_game_via_flame"
        },
        {
          name: "Play Game",
          url: "https://hamza-bayar-2.github.io/the_hunter/"
        }
      ]
    },
    {
      image: require("./assets/images/logos/fxSimulatorLogo.png"),
      projectName: "Flight Simulator",
      projectDesc:
        "A realistic flight simulation game built with Unity, featuring dual control options for both keyboard and mobile controller inputs, with real-time data transmission capabilities to ground stations for live flight monitoring and analytics.",
      footerLink: [
        {
          name: "View on GitHub",
          url: "https://github.com/FezaiTech/fxaltra"
        },
        {
          name: "Watch Video",
          url: "https://www.youtube.com/watch?v=mceU2-mPfhQ"
        }
      ]
    },
    {
      image: require("./assets/images/logos/dejavuEscapeLogo.webp"), // Using Unity/Game logo as placeholder
      projectName: "Dejavu Escape",
      projectDesc:
        "A puzzle game developed during the Magara Jam game development event using Unity game engine within 72 hours. Players try to find similar objects between rooms in this intriguing escape room experience.",
      footerLink: [
        {
          name: "Watch Video",
          url: "https://www.youtube.com/watch?v=5w-8k7wnMSI"
        },
        {
          name: "Download Game",
          url: "https://drive.google.com/file/d/1IHwOMOJqVoUEI3L9hOqocdxF9y7Bx8Db/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/logos/brmLogo.png"),
      projectName: "Bed Ridden Monitor",
      projectDesc:
        "A healthcare tracking application developed for Google Solution Challenge 2024, focusing on UN's 'Good Health and Well-being' goal. A system that monitors bedridden patients' health status using sensors and mobile app integration.",
      footerLink: [
        {
          name: "View on GitHub",
          url: "https://github.com/Hamza-Bayar-2/Bed-Ridden-Monitor"
        },
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1QekYLuq88qFq8bgNl-sAouzGuhaHTG6Q/view?usp=drive_link"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      image: require("./assets/images/logos/gdscLogo.png"),
      imageAlt: "Google GDSC Logo",
      title: "Google Developer Student Clubs Core Member",
      subtitle:
        "Certificate of Completion for successfully serving as a Google Developer Student Club core team member for the 2023 - 2024 academic year.",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1QpmE4pZTfVvK7Yjx5dstUPJqgzFVU9WY/view?usp=drive_link"
        }
      ]
    },
    {
      image: require("./assets/images/logos/flutterLogo.png"),
      imageAlt: "Google Flutter Logo",
      title: "Google Flutter Course",
      subtitle:
        "Successfully completed an online course offered by Google in 2024.",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1Z70jr0jnCabygpR611SaJY27t_Uw16m-/view?usp=drive_link"
        }
      ]
    },
    {
      image: require("./assets/images/logos/erasmusLogo.png"),
      imageAlt: "Erasmus Logo",
      title: "Erasmus+ Internship",
      subtitle:
        "Successfully completed my three-month internship in the Netherlands at Dutch Game Studio.",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1mWEFeMpbteswK2dTnqqkJT0lUYfFVCNN/view?usp=drive_link"
        }
      ]
    },

    {
      image: require("./assets/images/logos/qbronzeLogo.png"),
      imageAlt: "Qbronze Logo",
      title: "Quantum Computing & Programming",
      subtitle:
        "Successfully completed an online workshop offered by QTurkey in 2025.",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1cfZvKhu9KKucPxvoN-lEcCOJoqHmBlHo/view?usp=drive_link"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+90 543 630 79 85",
  email_address: "hamzabayar234@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
